import { createSlice } from "@reduxjs/toolkit";

/**
 * App-level right drawer.
 *
 * Only serialisable data lives here — a `type` naming which panel to show and
 * plain `props` for it. React nodes must never be put in the store, so the host
 * maps `type` to a component instead of the opener passing one in.
 */
const initialState = {
  open: false,
  type: "", // key in the host's registry
  props: {}, // serialisable props for that panel
  title: "",
  subtitle: "",
  width: 200,
};

const globalDrawerSlice = createSlice({
  name: "globalDrawer",
  initialState,
  reducers: {
    openDrawer: (state, action) => {
      const { type, props = {}, title = "", subtitle = "", width = 400 } = action.payload || {};
      state.open = true;
      state.type = type;
      state.props = props;
      state.title = title;
      state.subtitle = subtitle;
      if (width) state.width = width;
    },
    /** Update the shell without reopening — e.g. a panel switching to a sub-view. */
    setDrawerHeader: (state, action) => {
      const { title, subtitle } = action.payload || {};
      if (title !== undefined) state.title = title;
      if (subtitle !== undefined) state.subtitle = subtitle;
    },
    closeDrawer: () => initialState,
  },
});

export const { openDrawer, setDrawerHeader, closeDrawer } = globalDrawerSlice.actions;
export default globalDrawerSlice.reducer;
